import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { enums, sortPriorities } from '../../helpers';
import { Button, Dropdown, Icon, Flag, Input } from 'semantic-ui-react';
import ReactTable from "react-table";
import moment from 'moment';
import { ReviewRefundRequestModal } from '../../components';
import { invert } from 'lodash';
import { json2csv } from 'json-2-csv';

import './RefundManager.css';
import Popup from "semantic-ui-react/dist/es/modules/Popup/Popup";

export default class RefundManager extends Component {
  static propTypes = {
    operators: PropTypes.array,
    summary: PropTypes.array,
    refunds: PropTypes.array,
    getOperatorData: PropTypes.func,
    getRefundsSummary: PropTypes.func,
    getRefundData: PropTypes.func
  }

  constructor(props) {
    super(props);
    this.props.getOperatorData();
    this.props.getRefundsSummary();
    this.props.getRefundData();
    this.state = {
      showModal: false,
      showPreviewModal: false,
      exporting: false,
      rowCount: null,
      msisdn: null,
      entity: '',
      country: '',
      operator: '',
      method: ''
    }
  }

  onMsisdnChange = (e, {value}) => {
    this.props.getRefundData({ msisdn: value })
    this.setState({msisdn: value})
  }

  downloadDataAsCSV = () => {
    this.setState({ exporting: true });
    const { operators } = this.props;
    const isForMurica = this.props.refunds.every(refund => refund.countryId === 128 || refund.countryId === 32);
    const refunds = this.props.refunds.map(refund => ({
      "Case ID": refund._id,
      "Created At": refund.createdAt,
      "Updated At": refund.updatedAt,
      "Approved At": moment(refund.history[refund.history.length - 1].date).format('YYYY-MM-DD HH:mm'),
      "Entity": refund.entity,
      "Refund Method": enums.refundMethods[refund.refundMethod],
      "Country": operators.find(operator => operator.countryId === refund.countryId).countryName,
      "Operator": operators.find(operator => operator.oc === refund.oc).operatorName.replace(',', ' -'),
      "Service": operators.find(operator => operator.oc === refund.oc).services.find(service => refund.srvcId.toString() === service.id).name.replace(',', '-'),
      "Amount": refund.amount.value,
      "Currency": refund.amount.currency,
      "MSISDN": refund.msisdn,
      "Account No": '',
      "Last Name": '',
      ...(isForMurica && refund.bankDetails ? {
        "Account No": refund.bankDetails.accountNo || '',
        "Last Name": refund.bankDetails.lastName || ''
      } : {})
    }))
    json2csv(refunds, (err, data) => {
      var element = document.createElement("a");
      var file = new Blob([data], { type: "text/csv" });
      element.href = URL.createObjectURL(file);
      element.download = `export.csv`;
      element.click();
      this.setState({ exporting: false })
    })
  }

  clearMsisdn = () => {
    this.setState({ msisdn: '' });
    this.props.getRefundData({ msisdn: ''})
  }

  toggleModal = (caseId) => caseId ? this.setState({ showModal: caseId }) : this.setState({ showModal: false })

  togglePreviewModal = (caseId) => caseId ? this.setState({ showPreviewModal: caseId }) : this.setState({ showPreviewModal: false })

  closeModal = () => this.setState({ showModal: false })

  closePreviewModal = () => this.setState({ showPreviewModal: false })

  onFilterChange = (field) => (value, callback) => this.setState({[field]: value}, () => callback(value))

  render() {
    const countries = this.props.operators ? this.props.operators.reduce((countriesCurr, operator) => ({
      ...countriesCurr,
      [operator.countryISO]: operator.countryName
    }), {}) : {};

    const countryIdToISO = this.props.operators ? this.props.operators.reduce((countriesCurr, operator) => ({
      ...countriesCurr,
      [operator.countryId]: operator.countryISO
    }), {}) : {};

    const ocToName = this.props.operators ? this.props.operators.reduce((operatorsCurr, operator) => ({
      ...operatorsCurr,
      [operator.oc]: operator.operatorName
    }), {}) :{};

    const operators = this.props.operators ? this.props.operators.reduce((operatorsCurr, operator) => ({
      ...operatorsCurr,
      [operator.operatorName]: operator.operatorName
    }), {}) :{};

    const countriesToEntities = this.props.operators ? this.props.operators.reduce((acc, curr) => ({
      ...acc,
      [curr.countryISO]: Array.from(new Set([
        ...(acc[curr.countryISO] ? acc[curr.countryISO] : []),
        ...curr.services.map(service => service.entity)
      ]))
    }), {}) : {};

    const countryOptions = Object
      .keys(countries)
      .filter(country => this.props.refunds.map(refund => countryIdToISO[refund.countryId]).includes(country))
      .map(countryId => ({ key: countryId, value: countryId, text: countries[countryId] }))
      .filter(country => !this.state.entity || countriesToEntities[country.key].includes(this.state.entity))
      .filter(country => !this.state.operator || this.props.operators.find(operator => operator.countryISO === country.key && operator.operatorName === this.state.operator))
      .filter(country => !this.state.method || countriesToEntities[country.key].find(entity => enums.entityToRefundMethod[entity] ? enums.entityToRefundMethod[entity][invert(enums.refundMethods)[this.state.method]] : false))

    const operatorOptions = Object
      .keys(operators)
      .filter(operator => this.props.refunds.map(refund => ocToName[refund.oc]).includes(operator))
      .filter(operator => !this.state.entity || countriesToEntities[this.props.operators.find(operatorObj => operatorObj.operatorName === operator).countryISO].includes(this.state.entity))
      .filter(operator => !this.state.country || this.props.operators.find(operatorObj => operatorObj.operatorName === operator && operatorObj.countryISO === this.state.country))
      .filter(operator => !this.state.method || countriesToEntities[this.props.operators.find(operatorObj => operatorObj.operatorName === operator).countryISO].find(entity => enums.entityToRefundMethod[entity] ? enums.entityToRefundMethod[entity][invert(enums.refundMethods)[this.state.method]] : false))
      .map(operator => ({ key: operator, value: operator, text: operator }));

    const refundMethods = Object
      .values(enums.refundMethods)
      .filter(method => this.props.refunds.map(refund => enums.refundMethods[refund.refundMethod]).includes(method))
      .filter(method => !this.state.entity || enums.entityToRefundMethod[this.state.entity][invert(enums.refundMethods)[method]])
      .filter(method => !this.state.operator || countriesToEntities[this.props.operators.find(operator => operator.operatorName === this.state.operator).countryISO].find(entity => enums.entityToRefundMethod[entity] ? enums.entityToRefundMethod[entity][invert(enums.refundMethods)[method]] : false))
      .filter(method => !this.state.country || countriesToEntities[this.state.country].find(entity => enums.entityToRefundMethod[entity] ? enums.entityToRefundMethod[entity][invert(enums.refundMethods)[method]] : false))
      .map(method => ({ key: method, value: method, text: method }));

    const currencyOptions = Object
      .values(enums.currencies)
      .filter(currency => this.props.refunds.map(refund => enums.currencies[refund.amount.currency]).includes(currency))
      .map(currency => ({ key: currency, value: currency, text: currency }));

    const entityOptions = Object
      .keys(enums.entityToRefundMethod)
      .filter(entity => !this.state.method || (enums.entityToRefundMethod[entity] ? enums.entityToRefundMethod[entity][invert(enums.refundMethods)[this.state.method]] : false))
      .filter(entity => !this.state.country || countriesToEntities[this.state.country].includes(entity))
      .filter(entity => !this.state.operator || countriesToEntities[this.props.operators.find(operator => operator.operatorName === this.state.operator).countryISO].includes(entity))
      .filter(entity => this.props.refunds.map(item => item.entity).includes(entity))
      .map(entity => ({ key: entity, value: entity, text: entity }));

    return (
      <div className={`RefundManager main-content ${this.props.className ? this.props.className : ''}`}>
          <div className="RefundFilters">
              <div className="main-title">
                  Manage Refunds
                  <span className="main-title__length"> {this.state.rowCount === null ? this.props.refunds.length : this.state.rowCount}</span>
                  <div className="main-toolbar_item">
                    <Button onClick={this.downloadDataAsCSV} className="DownloadButton btn btn_blue" loading={this.state.exporting}>Export</Button>
                  </div>
              </div>
              <div className="main-toolbar">
                  <div className="main-toolbar_item">
                      <Input
                        onChange={this.onMsisdnChange}
                        icon={this.state.msisdn && this.state.msisdn.length ? <Icon name='remove' inverted circular link size="tiny" onClick={this.clearMsisdn} /> : null}
                        placeholder="MSISDN Lookup"
                        value={this.state.msisdn}
                      />
                  </div>
              </div>
          </div>
          <ReactTable
            data={this.props.refunds.slice().sort(sortPriorities).map(refund => ({
              ...refund,
              priority: refund.priority === 'HIGH' ? <Icon name="angle double up" color="red" /> : <Icon name="angle double down" color="green" />,
              priorityValue: refund.priority,
              // _id: <a style={{'cursor': 'pointer', textDecoration: 'underline'}} onClick={() => this.toggleModal(refund._id)}>{refund._id}</a>,
              createdAt: moment(refund.createdAt).format('YYYY-MM-DD HH:mm'),
              updatedAt: moment(refund.updatedAt).format('YYYY-MM-DD HH:mm'),
              approvedAt: moment(refund.history[refund.history.length - 1].date).format('YYYY-MM-DD HH:mm'),
              country: this.props.operators && this.props.operators.length ? <span><Flag name={this.props.operators.find(operator => operator.countryId === refund.countryId).countryISO.toLowerCase()} /> {countryIdToISO[refund.countryId]}</span> : null,
              countryISO: this.props.operators && this.props.operators.length ? this.props.operators.find(operator => operator.countryId === refund.countryId).countryISO : null,
              operator: this.props.operators && this.props.operators.length ? ocToName[refund.oc] : null,
              service: this.props.operators && this.props.operators.length ? this.props.operators.find(operator => operator.oc === refund.oc).services.find(service => refund.srvcId.toString() === service.id).name : null,
              actions: refund.status === 'APPROVED' ? <div style={{textAlign: 'center'}}>
                  <Popup
                      trigger={<Button size="mini" className="button-approve" icon='checkmark' compact onClick={(e) => {
                        e.stopPropagation();
                        this.props.updateStatus(refund._id, 'COMPLETED')
                      }}/>}
                      content="Complete"
                      inverted
                      size="mini"
                      position="bottom center"
                  />
              </div> : null,
              details: <div>
                {
                  refund && refund.bankDetails ?
                    Object
                      .keys(refund.bankDetails)
                      .map(detail => refund.bankDetails[detail] ? <span>{`${enums.bankDetails[detail]}: ${refund.bankDetails[detail]}`}<br /></span> : null) : null
                }
                {refund && ['bill_payment', 'api'].includes(refund.refundMethod) ? <span>{`MSISDN: ${refund.msisdn}`}</span> : null}
              </div>,
              totalAmount: refund.amount.value,
              refundMethod: enums.refundMethods[refund.refundMethod],
              currency: enums.currencies[refund.amount.currency]
            }))}
            columns={[
              {
                Header: 'Priority',
                accessor: 'priority',
                filterable: true,
                width: 77,
                filterMethod: ({value}, row) => value === row._original.priorityValue,
                Filter: ({ filter, onChange }) => <Dropdown
                  compact
                  placeholder="Priority"
                  fluid
                  search
                  options={[
                    {key: '', value: '', text: 'Select All'},
                    {
                      key: "HIGH",
                      value: "HIGH",
                      text: <span className="priority-icon-form"><Icon name="angle double up" color="red" /> High</span>
                    }, {
                      key: "NORMAL",
                      value: "NORMAL",
                      text: <span className="priority-icon-form"><Icon name="angle double down" color="green" />Normal</span>
                    }
                  ]}
                  onChange={(e, {value}) => onChange(value)}
                  value={ filter ? filter.value : '' }
                />
              },
              {Header: 'Case ID', accessor: '_id', width: 140, sortable: false},
              {Header: 'Approved At', accessor: 'approvedAt', width: 145 },
              {
                Header: 'Entity',
                accessor: 'entity',
                filterable: true,
                Filter: ({ filter, onChange }) => <Dropdown
                  compact
                  placeholder="Entity"
                  fluid
                  search
                  options={[{key: '', value: '', text: 'Select All'}, ...entityOptions]}
                  onChange={(e, {value}) => this.onFilterChange('entity')(value, onChange)}
                  value={ filter ? filter.value : '' }
                />

              },
              {
                Header: 'Country',
                accessor: 'country',
                filterable: true,
                width: 85,
                filterMethod: ({value}, row) => value === row._original.countryISO,
                Filter: ({ filter, onChange }) => <Dropdown
                  compact
                  placeholder="Country"
                  fluid
                  search
                  options={[{key: '', value: '', text: 'Select All'}, ...countryOptions]}
                  onChange={(e, {value}) => this.onFilterChange('country')(value, onChange)}
                  value={ filter ? filter.value : '' }
                />
              },
              {
                Header: 'Operator',
                accessor: 'operator',
                filterable: true,
                Filter: ({ filter, onChange }) => <Dropdown
                  compact
                  placeholder="Operator"
                  fluid
                  search
                  options={[{key: '', value: '', text: 'Select All'}, ...operatorOptions]}
                  onChange={(e, {value}) => this.onFilterChange('operator')(value, onChange)}
                  value={ filter ? filter.value : '' }
                />
              },
              {
                Header: 'Method',
                accessor: 'refundMethod',
                width: 140,
                filterable: true,
                Filter: ({ filter, onChange }) => <Dropdown
                  placeholder="Method"
                  fluid
                  search
                  compact
                  options={[{key: '', value: '', text: 'Select All'}, ...refundMethods]}
                  onChange={(e, {value}) => this.onFilterChange('method')(value, onChange)}
                  value={ filter ? filter.value : '' }
                />
              },
              {Header: 'Amount', accessor: 'totalAmount', width: 80},
              {
                Header: 'Currency',
                accessor: 'currency',
                filterable: true,
                width: 85,
                Filter: ({ filter, onChange }) => <Dropdown
                  compact
                  placeholder="Currency"
                  fluid
                  search
                  options={[{key: '', value: '', text: 'Select All'}, ...currencyOptions]}
                  onChange={(e, {value}) => onChange(value)}
                  value={ filter ? filter.value : '' }
                />
              },
              {Header: 'Details', accessor: 'details', width: 170, sortable: false},
              {Header: 'Process', accessor: 'actions', width: 69, sortable: false}
            ]}
            defaultPageSize={10}
            className="RefundManagerTable -striped"
            getTrProps={(state, rowInfo) => {
              return {
                onClick: (e) => rowInfo && (rowInfo.original.status === 'COMPLETED' || rowInfo.original.status === 'APPROVED') ? this.toggleModal(rowInfo.original._id) : this.togglePreviewModal(rowInfo.original._id),
                style: {
                  cursor: rowInfo ? 'pointer' : null,
                  ...(rowInfo && rowInfo.original.status === 'APPROVED' && rowInfo.original.history.find(el => el.change.find(item => item.field === 'status' && item.newValue === 'RETURNED' && (item.prevValue === 'APPROVED' || item.prevValue === 'COMPLETED'))) ? { backgroundColor: '#ffedf0'} : {})
                }
              }
            }}
            getLoadingProps={() => ({
                loadingText:
                    <div className="loading-widget loading-widget_table">
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                            <g fill="none" fill-rule="evenodd">
                                <path className="loading-widget__draw-animation" stroke="#4061AD" stroke-width="1" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="10" stroke-dasharray="300" stroke-dashoffset="300" fill="none" d="M19.783 5.792V.793c0-.581-.476-.82-1.057-.555L6.137 6.188c-.582.265-1.058.952-1.058 1.534v20.972c0 .582.476.82 1.058.556l13.62-6.427-4.655 2.222V13.488l-2.565 1.269v-5.58l7.246-3.385z"/>
                                <path className="loading-widget__draw-animation" stroke="#14AFE4" stroke-width="1" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="10" stroke-dasharray="300" stroke-dashoffset="300" fill="none" d="M26.21 2.75L18.435 6.4l1.322-.635V22.77l-4.655 2.195V13.488l-2.538 1.269v16.45c0 .581.476.82 1.057.555l12.589-5.924c.582-.264 1.058-.952 1.058-1.534V3.332c0-.608-.476-.846-1.058-.582z"/>
                            </g>
                        </svg>
                    </div>
            })}
            getPaginationProps={() => ({
                nextText: <Icon name="icon1 icon1_angle-right"  />,
                previousText: <Icon name="icon1 icon1_angle-left" />
            })}
            ref={el => this.tableInst = el}
            onFilteredChange={() => this.setState({ rowCount: this.tableInst.getResolvedState().sortedData.length })}
            loading={this.props.loading}
          />
          <div className="summary-bar clearfix">
            {this.props.entities.map(entity => (
            <div className="summary-bar__card">
              <div className="summary-card">
                <div className="summary-card__header">
                  {entity}
                </div>
                <div className="summary-card__body">
                  <div className="summary-card__item">
                    <div className="summary-card__title">
                        Normal Priority
                    </div>
                    <div className="summary-card__content">
                      <span>Total: {this.props.summary.filter(item => item._id.entity === entity && item._id.priority === 'NORMAL').reduce((acc, curr) => acc + curr.count, 0)}</span>
                      {
                          this.props.summary
                              .filter(item => item._id.entity === entity && item._id.priority === 'NORMAL')
                              .map(method => <span>{enums.refundMethods[method._id.refundMethod]}: {method.count}</span>)
                      }
                    </div>
                  </div>
                    <div className="summary-card__item">
                        <div className="summary-card__title">
                            High Priority
                        </div>
                        <div className="summary-card__content">
                          <span>Total: {this.props.summary.filter(item => item._id.entity === entity && item._id.priority === 'HIGH').reduce((acc, curr) => acc + curr.count, 0)}</span>
                          {
                              this.props.summary
                                  .filter(item => item._id.entity === entity && item._id.priority === 'HIGH')
                                  .map(method => <span>{enums.refundMethods[method._id.refundMethod]}: {method.count}</span>)
                          }
                        </div>
                    </div>
                </div>
              </div>
              </div>
            ))}
          </div>
          <ReviewRefundRequestModal
            initialValues={this.props.refunds.find(refund => refund._id === this.state.showModal)}
            open={this.state.showModal}
            close={this.closeModal}
            refundCount={this.props.refundCount}
            getRefundsCount={this.props.getRefundsCount}
            updateStatus={this.props.updateStatus}
            addComment={this.props.addComment}
            operators={this.props.operators}
            uploadFiles={this.props.uploadFiles}
            getTransactions={this.props.getTransactions}
            transactions={this.props.transactions}
            refunding={this.props.refunding}
            makeRefund={this.props.makeRefund}
            makeRefunds={this.props.makeRefunds}
            type="manager"
            uploading={this.props.uploading}
            loadingTransactions={this.props.loadingTransactions}
            switch={this.props.switch}
            switching={this.props.switching}
          />
          <ReviewRefundRequestModal
            initialValues={this.props.refunds.find(refund => refund._id === this.state.showPreviewModal)}
            open={this.state.showPreviewModal}
            close={this.closePreviewModal}
            refundCount={this.props.refundCount}
            getRefundsCount={this.props.getRefundsCount}
            addComment={this.props.addComment}
            operators={this.props.operators}
            uploadFiles={this.props.uploadFiles}
            getTransactions={this.props.getTransactions}
            transactions={this.props.transactions}
            refunding={this.props.refunding}
            makeRefund={this.props.makeRefund}
            makeRefunds={this.props.makeRefunds}
            type="requestor"
            uploading={this.props.uploading}
            loadingTransactions={this.props.loadingTransactions}
            switch={this.props.switch}
            switching={this.props.switching}
          />
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/RefundManagerRouteComponent/RefundManager.js